import React, { useState, useEffect } from 'react';
import Select from 'components/react-select';
import { getFrenchDepartments } from 'services/requests';

// Column Width
let columnWidth = 180;

// -------------------- HEADER -------------------- \\
const FrenchDepartmentHeader = () => {
    return (
        <div className="column-list" style={{ width: columnWidth }}>
            Département
        </div>
    );
};

// -------------------- FILTER -------------------- \\
const FrenchDepartmentFilter = ({ state, onSelectSearch }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        getFrenchDepartments().then(res => {
            if (res.status === 200) {
                setOptions(res.data.data.frenchDepartments.map(d => ({ label: (d.name + ' (' + d.number + ')'), value: d.id })));
            }
        });
    }, []);

    return (
        <div className="column-list" style={{ width: columnWidth }}>
            <Select
                placeholder="Département"
                value={state.french_departments}
                onChange={french_departments => onSelectSearch('french_departments', french_departments)}
                options={options}
                isMulti
            />
        </div>
    );
};

// -------------------- VALUE -------------------- \\
const FrenchDepartmentValue = ({ value }) => {
    return (
        <div className="column-list" style={{ width: columnWidth }}>
            {value}
        </div>
    );
};

export { FrenchDepartmentHeader, FrenchDepartmentFilter, FrenchDepartmentValue };
